import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityReportApi } from 'api';

import { entityReportQuery } from '../containers/Branding/Farm/Setting/commons/query';

export const createEntityReport = createAsyncThunk(
  'entityReport/createEntityReport',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityReportApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityReport = createAsyncThunk(
  'entityReport/findEntityReport',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityReportApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityReportById = createAsyncThunk(
  'entityReport/findEnityReportById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityReportApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityReport = createAsyncThunk(
  'entityReport/updateEntityReport',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntityReportApi.update(id, params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityReport = createAsyncThunk(
  'entityReport/deleteEntityReport',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityReportApi.delete(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
  query: entityReportQuery,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entityReportSlice = createSlice({
  name: 'entityReport',
  initialState,
  reducers: {
    reloadEntityReport(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityReport(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityReport(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityReport.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.tableList = data;
    });
  },
});

const { reducer: entityReportReducer, actions } = entityReportSlice;

export const {
  reloadEntityReport,
  updateSavedPaginationEntityReport,
  updateSavedListEntityReport,
} = actions;

export default entityReportReducer;
